<template>
  <div>
    <vue-tree
      ref="tree1"
      showCheckbox
      :treeData="options"
      :draggable="false"
      @on-drop="dropNode"
      @on-checked-item="checkedItem"
      @on-selected-change="clickNode"
      @on-checked-change="clickCheckbox"
    />
  </div>
</template>

<script>
export default {
  name: "PermissionCheckBox",
  props: {
    value: {
      type: Array,
      default: [],
    },
    options: {
      type: Array,
      default: [],
    },
    state: {
      type: Boolean,
      default: null,
    },
  },
  components: {},
  data: () => ({}),
  mounted() {},
  computed: {},
  watch: {
    value() {},
  },
  methods: {
    input(value) {
      this.$emit("input", value);
    },
    dropNode({ parentNode, targetNode, callback }) {
      // console.log("dropNode", parentNode, targetNode);
      // callback(targetNode);
    },
    checkedItem({ node, vNode }) {
      // this.$emit("input", vNode);
      // console.log("checkedItem", node, vNode);
    },
    clickNode(node) {
      // console.log("clickNode", node);
    },
    clickCheckbox({ node, selectedData }) {
      let value = selectedData.map((x) => x.id);
      this.$emit("input", value);
      // console.log("clickCheckbox", node, selectedData);
    },
  },
};
</script>

<style>
.vue-tree {
  border: 1px solid rgb(0, 0, 0, 0.5);
  padding: 5px;
}
.rotate180-leave {
  transform: rotate(270deg) !important;
}
.rotate180-enter {
  transform: rotate(0deg) !important;
}
</style>
